module.exports = __webpack_public_path__ + "media/images/icons/camera-eb2b5d2ce7555716a18bd44a643606c0.svg";